/**
 * @flow
 * @relayHash a1114f968f27a66b9ad59a1cfd774baa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteAiConversationInput = {|
  conversationId: string
|};
export type DeleteAiConversationMutationVariables = {|
  input: DeleteAiConversationInput
|};
export type DeleteAiConversationMutationResponse = {|
  +deleteAiConversation: {|
    +success: boolean
  |}
|};
export type DeleteAiConversationMutation = {|
  variables: DeleteAiConversationMutationVariables,
  response: DeleteAiConversationMutationResponse,
|};
*/


/*
mutation DeleteAiConversationMutation(
  $input: DeleteAiConversationInput!
) {
  deleteAiConversation(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteAiConversationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteAiConversation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAiConversationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteAiConversationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteAiConversationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteAiConversationMutation",
    "id": null,
    "text": "mutation DeleteAiConversationMutation(\n  $input: DeleteAiConversationInput!\n) {\n  deleteAiConversation(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '63ac3fff67280612e4f49cc92c0a5c9d';
module.exports = node;
